<template>
  <a-modal
    class="attach-sample-modal"
    :title="modalTitle"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        {{ mode === "edit" ? $t("Common_Modify") : $t("Common_Enroll") }}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-group">
      <div v-if="mode !== 'edit'" class="content-item">
        <div class="modal-title">{{$t("Sample7")}}</div>
        <form class="file-upload-form">
          <div class="file-input" :class="{ active: active }">
            <label v-if="!!file">{{ file.name }}</label>
            <label v-else>{{$t("TP_Edit_2_Side_15")}}</label>
            <input
              type="file"
              @dragEnter="() => handleActive(true)"
              @dragLeave="() => handleActive(false)"
              @change="(e) => handleFile(e)"
            />
          </div>
        </form>
      </div>
      <div class="content-item">
        <InputComponent
          type="text"
          :title="$t('Common_Content')"
          moduleName="attachSample"
          name="contents"
          :value="contents"
          :validation="['required']"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { toRefs, ref, reactive, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl } from "@/utils/common";
import InputComponent from "@/components/commonComponents/InputComponent";
import { useI18n } from "vue-i18n";

export default {
  name: "SampleUploadEditModal",
  props: {
    mode: String,
    visible: Boolean,
    toggleModal: Function,
    attachInfo: Object,
  },
  components: {
    InputComponent,
  },
  setup(props) {
    const store = useStore();
    const { t } = useI18n();
    const inputValues = computed(
      () => store.getters["attachSample/GET_INPUT_VALUES"]
    );
    const modalTitle = props.mode === "edit" ? t("Sample6") : t("Sample8");

    const state = reactive({
      loading: false,
      active: false,
      contents:
        props.mode === "edit" ? props.attachInfo.attachSampleContent : "",
      file: null,
    });

    onMounted(() => {
      store.dispatch("attachSample/SET_INPUT_VALUE", {
        contents: state.contents,
      });
    });

    onUnmounted(() => {
      // 입력 값 초기화
      store.dispatch("attachSample/INIT_INPUT_VALUE");
    });

    // 파일 영역 활성화
    const handleActive = (value) => {
      state["active"] = value;
    };

    // 파일 선택 이벤트
    const handleFile = (e) => {
      state["active"] = false;
      state["file"] = e.target.files[0];
    };

    // 샘플 취소 이벤트
    const handleCancel = () => {
      props.toggleModal();
    };

    // 샘플 수정/업로드 이벤트
    const handleOk = async () => {
      // 샘플 수정
      if (props.mode === "edit") {
        if (!inputValues.value.contents) return;
        if (
          props.attachInfo.attachSampleContent !== inputValues.value.contents
        ) {
          state.loading = true;
          const params = {
            attachSampleNo: props.attachInfo.attachSampleNo,
            content: inputValues.value.contents,
          };

          try {
            const response = await axios.put(apiUrl + "AttachSample", params);
            if (response && !response.data.error) {
              store.dispatch("attachSample/UPDATE_ATTACH_SAMPLE", response);
            }
          } catch (error) {
            console.log("attach file edit error", error);
          }
        }
        state.loading = false;
        props.toggleModal();
      }
      // 샘플 업로드
      else {
        if (!!inputValues.value.contents && !!state.file) {
          state.loading = true;
          const formData = new FormData();
          formData.append("content", inputValues.value.contents);
          formData.append("file", state.file);

          try {
            const response = await axios.post(
              apiUrl + "AttachSample",
              formData
            );
            if (response && !response.data.error) {
              store.dispatch("attachSample/UPLOAD_ATTACH_SAMPLE", response);
            }
          } catch (error) {
            console.log("attach file upload error", error);
          }

          state.file = null;
          state.loading = false;
          props.toggleModal();
        }
      }
    };

    return {
      ...toRefs(state),
      modalTitle,
      handleActive,
      handleFile,
      handleOk,
      handleCancel,
    };
  },
};
</script>